import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { get } from 'lodash'
import { MaterialModal } from 'components/layout'
import { Input, InputPassword } from 'components/fields'
import { form } from 'helpers/decorators'
import { apiConfiguration, apiDashboard } from 'helpers/decorators/api'
import {  validate, asyncValidate } from './change-password.validation'
import { connect } from 'react-redux'
import { checkPasswordEmail } from '../../../../redux/modules/api/asyncValidations'
import { CONFIGURATION_KEYS } from '../../../../constants/enums'


@apiDashboard.apiPersons()
@apiConfiguration()
@connect(state => ({
  isSubmitting: get(state, 'api.dashboard.persons.profile.loading')
}), { checkPasswordEmail })
@form({
  form: 'resetUserPassword',
  disableHook: true,
  validate,
  asyncValidate
})
class ResetPassword extends Component {
  static propTypes = {
    onChangePassword: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    profile: PropTypes.object,
    id: PropTypes.string,
    userType: PropTypes.string,
    orgId: PropTypes.number,
    checkPasswordEmail: PropTypes.func,
    isSubmitting: PropTypes.bool,
    onGetConfigurationValue: PropTypes.func.isRequired
  }

  componentDidMount = async ()=> {
    await this.props.onGetConfigurationValue(CONFIGURATION_KEYS.passwordSpecChars.id, null, true)
  }

  handleSubmit = values => {
    const id = get(this.props.profile, 'data.id') || this.props.id

    const data = {
      ...values,
      userType: this.props.userType,
      orgId: this.props.orgId
    }

    this.props.onChangePassword(id, data, {
      resetForm: this.props.reset,
      skipLoadProfile: true
    })
  }

  render () {
    const { handleSubmit, isSubmitting } = this.props

    const passwordSpecChars = get(this.props, `configuration.values.${CONFIGURATION_KEYS.passwordSpecChars.id}.textValue`)

    return (
      <form onSubmit={handleSubmit(this.handleSubmit)}>
        <div className="row">
          <div className="col-xs-12">
            <Input
              name="currentPassword"
              label="Old Password"
              intlKey="label.old_again"
              type="password"
            />
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12">
            <InputPassword
              name="newPassword"
              label="New Password"
              intlKey="label.new_password"
              type="password"
              passwordSpecChars={passwordSpecChars}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12">
            <Input
              name="newPasswordAgain"
              label="New Password again"
              intlKey="label.new_password_again"
              type="password"
            />
          </div>
        </div>
        <MaterialModal.Footer
          action="Change password"
          actionKey="button.change_password"
          insideContent
          isLoading={isSubmitting}
        />
      </form>
    )
  }
}

export default ResetPassword
